import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

interface BoltBadgeProps {
  className?: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const BoltBadge: React.FC<BoltBadgeProps> = ({ 
  className = '',
  position = 'bottom-left'
}) => {
  const positionClasses = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4'
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className={`fixed ${positionClasses[position]} z-40 ${className}`}
    >
      <a
        href="https://bolt.new"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center space-x-2 bg-black/80 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 hover:bg-black/90 transition-all duration-200"
      >
        <div className="w-6 h-6 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center">
          <Zap className="w-3 h-3 text-black" />
        </div>
        <span className="text-white text-sm font-medium group-hover:text-yellow-300 transition-colors">
          Built with Bolt.new
        </span>
      </a>
    </motion.div>
  );
};

export default BoltBadge;